var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextBlockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 10 10",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.57036 10H8.06004C7.98346 10 7.9148 9.95198 7.88861 9.87976L7.12552 7.77222C7.09933 7.7 7.03107 7.65198 6.95409 7.65198H3.08544C3.00885 7.65198 2.9402 7.7 2.91401 7.77222L2.15092 9.87976C2.12473 9.95198 2.05647 10 1.97949 10H0.482265C0.354487 10 0.266392 9.87143 0.312424 9.75238L4.02949 0.116667C4.05647 0.0464286 4.12433 0 4.19933 0H5.8529C5.9283 0 5.99576 0.0464286 6.02274 0.116667L9.7398 9.75238C9.78584 9.87183 9.69774 10 9.56996 10H9.57036ZM6.26401 6.07857C6.3902 6.07857 6.4783 5.95317 6.43544 5.83452L5.76203 3.97222C5.71957 3.8623 5.66679 3.72262 5.60369 3.55357C5.5402 3.38452 5.47234 3.20476 5.40052 3.01429C5.32869 2.82381 5.26084 2.63571 5.19734 2.4496C5.19655 2.44762 5.19615 2.44603 5.19536 2.44405C5.1398 2.28095 4.91044 2.27897 4.85171 2.44087C4.85052 2.44365 4.84973 2.44683 4.84853 2.4496C4.78068 2.63571 4.71322 2.82381 4.64536 3.01429C4.5775 3.20476 4.51203 3.38452 4.44853 3.55357C4.38504 3.72302 4.33226 3.8627 4.2902 3.97222L3.61679 5.83452C3.57393 5.95317 3.66203 6.07857 3.78822 6.07857H6.26401Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextBlockIcon);
export default __webpack_public_path__ + "static/media/TextBlockIcon.e364cae078e35378d411c5f47863a8f8.svg";
export { ForwardRef as ReactComponent };